"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICellEvolutionNewWorld__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellno",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_adaption",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_surviveability",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_division",
                type: "uint256",
            },
        ],
        name: "checkdeath",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_cellno",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_adaption",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_surviveability",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_division",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_environment",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_day",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_totalscore",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_finaltitle",
                type: "string",
            },
        ],
        name: "dnamerge",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellDBId",
                type: "uint256",
            },
        ],
        name: "getCellDB",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "creator",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "finaltitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "belong",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellEvolution",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellHistoryId",
                type: "uint256",
            },
        ],
        name: "getCellHistory",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "worldtitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "startcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "cellsdetail",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellHistory",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inheritance",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "newinheritance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellno",
                type: "uint256",
            },
        ],
        name: "setCellno",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_worldId",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_newtitle",
                type: "string",
            },
        ],
        name: "setHomeworld",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_isopen",
                type: "bool",
            },
        ],
        name: "setIsOpen",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_versionno",
                type: "uint256",
            },
        ],
        name: "setVersion",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_historyno",
                type: "uint256",
            },
        ],
        name: "sethistoryno",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "worldtitlecheck",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "creator",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "finaltitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "belong",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellEvolution",
                name: "_cellDB",
                type: "tuple",
            },
        ],
        name: "writecell",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "worldtitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "startcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "cellsdetail",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellHistory",
                name: "_worldDB",
                type: "tuple",
            },
        ],
        name: "writeworld",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class ICellEvolutionNewWorld__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ICellEvolutionNewWorld__factory = ICellEvolutionNewWorld__factory;
ICellEvolutionNewWorld__factory.abi = _abi;
//# sourceMappingURL=ICellEvolutionNewWorld__factory.js.map